import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconHome = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <path
            d="M21.76,12.14a1,1,0,0,1-.76.36,1,1,0,0,1-.64-.23L20,12V18.5a2,2,0,0,1-2,2H15a1,1,0,0,1-1-1v-4a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H6a2,2,0,0,1-2-2V12l-.36.3a1,1,0,0,1-1.28-1.54l7.77-6.54a2.86,2.86,0,0,1,3.74,0l7.77,6.54A1,1,0,0,1,21.76,12.14Z"
            fill="currentColor"/>
      </svg>
  )
}

TLIconHome.defaultProps = {
  className: '',
  height: 24,
  width: 24,
  tooltip: null
}
